if ($('[data-confirm]').length) {
    $('[data-confirm]').on('click', function (e) {
        if (!window.confirm($(this).data('confirm'))) {
            e.preventDefault();
        }
    });
}
